import { SETTINGS_ENABLE_CONSTRUCTOR_SCRIPTS_SLUG } from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsConstructorScriptsEnabled = () =>
    useSettingsFactory({
        settingsConstructorScriptsEnabled: {
            path: SETTINGS_ENABLE_CONSTRUCTOR_SCRIPTS_SLUG,
        },
    });
